/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'motion/react'
import { trackEvent } from 'analytics/trackFunctions'
import { useDesktopSideMenuStore, useSelectedMenuStore } from 'store'
import { WayniIcon, WayniTextIcon } from 'assets/icons'
import LogoutModal from 'components/LogoutModal'
import {
  MEMBERSHIP_BUTTON,
  PRIMARY_NAV,
  SECONDARY_NAV,
  LOGOUT_BUTTON
} from './menus'
import MenuButton from './MenuButton'

const DesktopMenu = () => {
  const { isOpen, updateMenuIsOpen } = useDesktopSideMenuStore()
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState<boolean>(false)

  const navigate = useNavigate()
  const { selectedMenu, updateSelectedMenu } = useSelectedMenuStore()

  const getIconClass = (id: string) =>
    `max-w-full w-6 ${
      selectedMenu === `/${id}` || selectedMenu === id
        ? '!stroke-[#08724C]'
        : 'stroke-green-800'
    }`

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [isOpen])

  return (
    <motion.section
      animate={{
        width: isOpen ? 280 : 86
      }}
      transition={{ duration: 0.25 }}
      initial={false}
      className='bg-white rounded-r-lg hidden fixed left-0 top-0 md:flex md:flex-col h-screen max-h-screen z-99 overflow-hidden'
      onFocus={() => {
        updateMenuIsOpen(true)
      }}
      onMouseOver={(e) => {
        e.stopPropagation()
        updateMenuIsOpen(true)
      }}
      onMouseOut={() => {
        updateMenuIsOpen(false)
      }}
    >
      <div className='bg-green-800 flex shrink-0 gap-2 px-2 h-[4.5rem] items-center justify-center overflow-x-hidden transition-all'>
        <WayniIcon />
        <WayniTextIcon
          className={`transition-all ${
            isOpen ? 'opacity-100 block' : 'opacity-0 hidden'
          }`}
        />
      </div>
      <div className='bg-white px-2 pt-8'>
        <nav
          className={`max-h-[calc(100vh_-_12.25rem)] overflow-x-hidden ${
            isOpen ? 'overflow-y-auto' : 'overflow-y-hidden'
          }`}
        >
          <div className='flex flex-col gap-2'>
            {[...PRIMARY_NAV].map((b) => (
              <MenuButton
                key={b.id}
                selected={selectedMenu === `/${b.id}` || selectedMenu === b.id}
                label={b.text}
                icon={<b.Icon className={getIconClass(b.id)} />}
                extended={isOpen}
                onClick={() => {
                  updateSelectedMenu(b.id)
                  navigate(`/${b.id}`)
                }}
              />
            ))}
          </div>

          <hr className='h-[1px] w-full bg-gray-300 my-3' />

          <MenuButton
            selected={
              selectedMenu === `/${MEMBERSHIP_BUTTON.id}` ||
              selectedMenu === MEMBERSHIP_BUTTON.id
            }
            label={MEMBERSHIP_BUTTON.text}
            icon={
              <MEMBERSHIP_BUTTON.Icon
                className={getIconClass(MEMBERSHIP_BUTTON.id)}
              />
            }
            extended={isOpen}
            isMembership
            onClick={() => {
              updateSelectedMenu(MEMBERSHIP_BUTTON.id)
              navigate(`/${MEMBERSHIP_BUTTON.id}`)
            }}
          />

          <hr className='h-[1px] w-full bg-gray-300 my-3' />

          <div
            className={`flex flex-col gap-2 ${
              isOpen ? 'h-auto' : 'max-h-[20%]'
            }`}
          >
            {SECONDARY_NAV.map((b) => (
              <MenuButton
                key={b.id}
                selected={selectedMenu === `/${b.id}` || selectedMenu === b.id}
                label={b.text}
                icon={
                  <b.Icon
                    className={getIconClass(b.id)}
                    fill={selectedMenu === `/${b.id}` ? '#08724C' : '#0FD08B'}
                  />
                }
                extended={isOpen}
                onClick={() => {
                  if (b.event) trackEvent({ eventName: b.event })
                  updateSelectedMenu(b.id)
                  navigate(`/${b.id}`)
                }}
              />
            ))}
          </div>
        </nav>

        <hr className='h-[1px] w-full bg-gray-300 my-3' />

        <MenuButton
          selected={selectedMenu === `/${LOGOUT_BUTTON.id}`}
          label={LOGOUT_BUTTON.text}
          icon={
            <LOGOUT_BUTTON.Icon className={getIconClass(LOGOUT_BUTTON.id)} />
          }
          extended={isOpen}
          onClick={() => {
            updateMenuIsOpen(false)
            setIsLogoutModalOpen(true)
          }}
        />
        <LogoutModal
          isOpen={isLogoutModalOpen}
          setIsOpen={setIsLogoutModalOpen}
        />
      </div>
    </motion.section>
  )
}

export default DesktopMenu
